import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {LoadStore} from './stores';
/**
 * LoadBar
 */
export default class LoadBar extends React.Component {
  static displayName = 'LoadBar';
  static propTypes = {children: PropTypes.any};
  static defaultProps = {};
  /**
   * @constructor
   * @param  {Object} props
   */
  constructor(props) {
    super(props);
    this.state = {isLoading: false};
    _.bindAll(this, 'onLoadStoreChange');
    this.onLoadStoreChange = _.throttle(this.onLoadStoreChange, 475);
  }

  /**
   * THe load store changes, update state
   * @param  {Object} loadStoreState
   */
  onLoadStoreChange(loadStoreState) {
    this.setState({
      isLoading: loadStoreState.processes > 0,
    });
  }

  /**
   * @override
   */
  componentDidMount() {
    LoadStore.listen(this.onLoadStoreChange);
  }

  /**
   * @override
   */
  componentWillUnmount() {
    LoadStore.unlisten(this.onLoadStoreChange);
  }

  /**
   * @override
   */
  render() {
    if (!this.state.isLoading) return false;
    return (
      <div className="loader__container">
        <div className="loader">
          <div className="loader__bar" />
          <div className="loader__bar" />
          <div className="loader__bar" />
        </div>
      </div>
    );
  }
}
